import React, { useState, useEffect } from 'react';
import { Grid, GridColumn } from '@progress/kendo-react-grid';
import helper from '../Shared/helper'
import defaultPhoto from '../Shared/photo_not_found.png'

const MatrixUserRecord = (matrixdata) => {
    const [apiURL, setApiURL] = useState('');
    const [photoError, setPhotoError] = useState(false);
    const [dataError, setDataError] = useState(false);
    const [userInfo, setUserInfo] = useState([])
    const [extraUserInfo, setExtraUserInfo] = useState([])
    const [userData, setUserData] = useState([])
    const [credentials, setCredentials] = useState([])
    const [employeeData, setEmployeeData] = useState([])
    const [badges, setBadges] = useState([])
    const apiRootURL = helper.getProxyRootURL();

    const renderKeyCell = (props) => <td style={{ whiteSpace: 'nowrap', verticalAlign: 'top' }}>{props.dataItem.key}</td>

    const renderValueCell = (props) => {
        const { dataItem, field } = props;
        const value = dataItem[field];

        if (typeof value === 'object') {
            return <td><pre>{JSON.stringify(value, null, 2)}</pre></td>;
        }

        return <td>{value}</td>;
    };

    const CredentialDetailComponent = (props) => {
        return (
            <Grid data={cleanData(props.dataItem.credentialData)} resizable={true}>
                <GridColumn field="key" title="Key" width="200px" cell={renderKeyCell} />
                <GridColumn field="value" title="Value" cell={renderValueCell} />
            </Grid>
        );
    };

    const BadgeDetailComponent = (props) => {
        return (
            <Grid data={cleanData(props.dataItem.badgedata)} resizable={true}>
                <GridColumn field="key" title="Key" width="200px" cell={renderKeyCell} />
                <GridColumn field="value" title="Value" cell={renderValueCell} />
            </Grid>
        );
    };

    const EmployeeDetailComponent = (props) => {
        return (
            <Grid data={cleanData(props.dataItem.employeeData)} resizable={true}>
                <GridColumn field="key" title="Key" width="200px" cell={renderKeyCell} />
                <GridColumn field="value" title="Value" cell={renderValueCell} />
            </Grid>
        );
    };

    const cleanData = (data) => {
        const cleanedData = [];

        for (let key in data) {
            if (
                data.hasOwnProperty(key) &&
                data[key] !== undefined &&
                data[key] !== null &&
                !isStringEmptyOrWhiteSpace(data[key])
            ) {
                let value = data[key]
                if (typeof value === 'boolean') {
                    value = value ? 'true' : 'false';
                }
                if (key === 'user1') {
                    key = 'Org Name (user1)'
                }
                if (key === 'user2') {
                    key = 'Working Title (user2)'
                }
                if (key === 'user3') {
                    key = 'Supplier Names (user3)'
                }
                if (key === 'user5') {
                    key = 'Role Descriptions (user5)'
                }
                if (key === 'user6') {
                    key = 'Role Details (user6)'
                }
                if (key === 'user7') {
                    key = 'Job Titles (user7)'
                }
                if (key === 'user16') {
                    key = 'Workforce ID (user16)'
                }
                cleanedData.push({ key, value });
            }
        }
        return cleanedData
    }

    const isStringEmptyOrWhiteSpace = (str) => {
        if (typeof str !== 'string') {
            return false
        }
        return str.trim() === '';
    };

    const expandCredential = (event) => {
        let newData = credentials.map((item) => {
            if (item.credential === event.dataItem.credential) {
                item.expanded = !event.dataItem.expanded;
            }
            return item;
        });
        setCredentials(newData);
    };

    const expandBadge = (event) => {
        let newData = badges.map((item) => {
            if (item.badgeID === event.dataItem.badgeID) {
                item.expanded = !event.dataItem.expanded;
            }
            return item;
        });
        setBadges(newData);
    };

    const expandEmployeeData = (event) => {
        let newData = employeeData.map((item) => {
            if (item.employeeID === event.dataItem.employeeID) {
                item.expanded = !event.dataItem.expanded;
            }
            return item;
        });
        setEmployeeData(newData);
    };

    const cellWithBackGround = (props) => {
        let style = {}
        if (props.dataItem.status === 'Valid') {
            style = {
                backgroundColor: "rgb(55, 180, 0,0.32)",
            };
        }
        if (props.dataItem.status === 'Terminated') {
            style = {
                backgroundColor: "rgb(243, 23, 0, 0.32)",
            };
        }
        return (
            <td style={style}>
                {props.dataItem.status}
            </td>
        );
    };

    useEffect(() => {
        setApiURL(defaultPhoto)
        let personID = ''
        let userinfo = []
        let extraUserinfo = []
        if (matrixdata && matrixdata.data) {
            matrixdata.data.map(item => {
                if (item['key'] === 'userData') {
                    setUserData(cleanData(item.value))
                }
                else if (item['key'] === 'badges') {
                    let badges = []
                    if (item.value.length) {
                        item.value.map(badge => {
                            badges.push({
                                'badgeName': badge.name,
                                'badgeID': badge.badgeID,
                                'badgedata': badge
                            })
                        })
                    }
                    setBadges(badges)
                }
                else if (item['key'] === 'credentials') {
                    let credentials = []
                    const credArray = Object.values(item)
                    if (credArray[1]) {
                        credArray[1].map(credential => {
                            credentials.push({
                                'credential': credential.credentialID,
                                'credentialData': credential,
                                'number': credential.credentialNumber,
                                'status': credential.status,
                                'modified': credential.modifiedDateTime
                            })
                        })
                    }
                    credentials.sort((a, b) => {
                        if (a.status < b.status) return 1;
                        if (a.status > b.status) return -1;
                        return 0;
                    });
                    setCredentials(credentials)
                }
                else if (item['key'] === 'employees') {
                    if (item.value[0]) {
                        setEmployeeData([{
                            'employeeID': item.value[0].employeeID,
                            'employeeNum': item.value[0].employeeNum,
                            'employeeData': item.value[0]
                        }])
                    }
                }
                else {
                    const importantFields = ['personID', 'lastName', 'firstName', 'middleName', 'status', 'inactiveReason', 'alternateFirstName', 'modifiedDateTime']
                    if (item['key'] === 'personID') {
                        personID = item.value
                    }

                    const itemArray = Object.values(item)
                    if (itemArray[1]) {
                        if (importantFields.includes(itemArray[0])) {
                            userinfo.push(item)
                        }
                        else {
                            if (itemArray[1].length) {
                                extraUserinfo.push(item)
                            }
                        }
                    }
                }
            })

            if (Number(personID) === 0) {
                setDataError(true)
            }

            setUserInfo(userinfo)
            setExtraUserInfo(extraUserinfo)
            if (personID) {
                setApiURL(`${apiRootURL}Photo/id=${personID}`)
            }
        }
    }, [matrixdata])

    return (
        <div>
            <h1>Matrix Record</h1>
            <div className='img-container'>
                {matrixdata && !photoError
                    ? <img height={125} src={apiURL} onError={() => setPhotoError(true)} alt="Matrix User" />
                    : <img height={125} src={defaultPhoto} alt="No User Found" />
                }
            </div>
            {userInfo && !dataError && (
                <Grid data={userInfo} resizable={true}>
                    <GridColumn field="key" title="Key" width="200px" cell={renderKeyCell} />
                    <GridColumn field="value" title="Value" cell={renderValueCell} />
                </Grid>
            )}
            {!dataError && <h2>Credentials</h2>}
            {credentials && !dataError && (
                <Grid data={credentials} resizable={true} detail={CredentialDetailComponent} expandField="expanded" onExpandChange={expandCredential}>
                    <GridColumn field="status" title='Status' cell={cellWithBackGround} width="120px" />
                    <GridColumn field="credential" title='ID' width="100px" />
                    <GridColumn field="number" title='Number' width="130px" />
                    <GridColumn field="modified" title='Modified' />
                </Grid>
            )}
            {!dataError && <h2>Badges</h2>}
            {badges && !dataError && (
                <Grid data={badges} resizable={true} detail={BadgeDetailComponent} expandField="expanded" onExpandChange={expandBadge}>
                    <GridColumn field="badgeName" title="Name" width="200px" />
                    <GridColumn field="badgeID" title="ID" />
                </Grid>
            )}
            {!dataError && <h2>User Data</h2>}
            {userData && !dataError && (
                <Grid data={userData} resizable={true}>
                    <GridColumn field="key" title="Key" width="200px" cell={renderKeyCell} />
                    <GridColumn field="value" title="Value" cell={renderValueCell} />
                </Grid>
            )}
            {!dataError && <h2>Employee Data</h2>}
            {employeeData && !dataError && (
                <Grid data={employeeData} resizable={true} detail={EmployeeDetailComponent} expandField="expanded" onExpandChange={expandEmployeeData}>
                    <GridColumn field="employeeID" title="Employee ID" />
                    <GridColumn field="employeeNum" title="Employee Number" />
                </Grid>
            )}
            {!dataError && <h2>Other Data</h2>}
            {extraUserInfo && !dataError && (
                <Grid data={extraUserInfo} resizable={true}>
                    <GridColumn field="key" title="Key" width="200px" cell={renderKeyCell} />
                    <GridColumn field="value" title="Value" cell={renderValueCell} />
                </Grid>
            )}
            {dataError && <p>Something went wrong fetching this record. Try Searching again.</p>}
        </div>
    );
};

export default MatrixUserRecord;